import React from 'react';
import Phone from './Phone';
import PropTypes from 'prop-types';

export const WelcomeConfirmed = ({ agent, hours }) => {
  return (
    <>
      <h4>Thank you!</h4>
      <p>
        Your contact information is confirmed, and we're reviewing your order.
        You'll receive another text in a day or two so you can confirm all of
        the details about your new countertops.
      </p>
      <p>
        If you have questions, please call <Phone />.{' '}
        {hours && <>I work {hours}.</>}
      </p>
      <p style={{ fontStyle: 'italic' }}>-{agent}</p>
      <hr />
    </>
  );
};

WelcomeConfirmed.propTypes = {
  agent: PropTypes.string,
  hours: PropTypes.string
};

export default WelcomeConfirmed;
